<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;
  }
</style>
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a routerLink="/corporate/marketing-tool">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Email Templates
      </li>
    </ol>
  </nav>
</div>

<div class="container mt-2 themeTblReso position-relative z-in99">
  <div class="container-fluid py-3 bg-light min-vh-100">
    <!-- Header -->
    <div
      class="d-flex justify-content-end align-items-center mb-3 flex-wrap gap-2"
    >
      <div
        class="d-flex flex-wrap align-items-center justify-content-between gap-2 w-100"
        style="gap: 15px"
      >
        <div class="cb-template-filter">
          <mat-form-field
            appearance="outline"
            class="formstyle matSelectDropdown"
          >
            <mat-label>Select Company Name</mat-label>
            <mat-select
              [(value)]="companyID"
              (selectionChange)="onCompanyChange($event)"
            >
              <mat-option
                *ngFor="let userObj of getCompanyobj"
                [value]="userObj.customer_id"
              >
                {{ userObj.customer_company_name }}
              </mat-option>
              <mat-option
                *ngIf="!getCompanyobj || getCompanyobj.length === 0"
                disabled
              >
                No data available
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <div class="form-group">
            <label for="domainName">Select Domain </label>
            <select
              id="domainName"
              class="form-control formstyle"
              [(ngModel)]="domainID"
              (change)="onDomainChange($event)"
            >
              <option value="" disabled>Select Domain</option>
              <option
                *ngFor="let domainObj of domainData"
                [value]="domainObj.id"
              >
                {{ domainObj.domain_name }}
              </option>
            </select>
          </div> -->

          <mat-form-field
            appearance="outline"
            class="formstyle matSelectDropdown"
          >
            <mat-label>Select Domain</mat-label>
            <mat-select
              [(value)]="domainID"
              (selectionChange)="onDomainChange($event)"
            >
              <mat-option
                *ngFor="let domainObj of domainData"
                [value]="domainObj.id"
              >
                {{ domainObj.domain_name }}
              </mat-option>
              <mat-option
                *ngIf="!domainData || domainData.length === 0"
                disabled
              >
                No data available
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="formstyle matSelectDropdown"
          >
            <mat-label>Select Journey</mat-label>
            <mat-select
              [(value)]="journeyID"
              (selectionChange)="onJourneyChange($event)"
            >
              <mat-option [value]="null">— None —</mat-option>
              <mat-option
                *ngFor="let userObj of jorneyType"
                [value]="userObj.journey_id"
              >
                {{ userObj.journey_name }}
              </mat-option>
              <mat-option
                *ngIf="!jorneyType || jorneyType.length === 0"
                disabled
              >
                No data available
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="formstyle matSelectDropdown"
          >
            <mat-label>Select Theme</mat-label>
            <mat-select
              multiple
              [(value)]="themesID"
              (selectionChange)="onThemeChange($event)"
            >
              <mat-option
                *ngFor="let userObj of themeList"
                [value]="userObj.theme_id"
              >
                {{ userObj.theme_name }}
              </mat-option>
              <mat-option *ngIf="!themeList || themeList.length === 0" disabled>
                No data available
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="filter-btnsd-wrapper d-flex align-items-center"
            style="gap: 10px"
          >
            <button class="btn clear-filter-btn" (click)="clearFilter()">
              Clear
            </button>
            <input
              type="button"
              value="Add New"
              class="custbtn m-0 shadow-none"
              routerLink="/corporate/cb-email-builder"
            />
          </div>
        </div>
      </div>
      <div
        class="template-serach col px-0 pt-2 d-flex align-items-center justify-content-between"
      >
        <div class="input-group">
          <div class="input-group-prepend">
            <span
              class="input-group-text bg-white border-right-0 pr-0"
              style="border-color: #eaedf2"
              id="basic-addon1"
              ><i class="bi bi-search"></i
            ></span>
          </div>
          <input
            type="text"
            class="form-control border-left-0"
            placeholder="Username"
            aria-label="Username"
            aria-describedby="basic-addon1"
            placeholder="Search in template..."
            [(ngModel)]="searchTemplateText"
            (input)="searchTemplate()"
          />
        </div>
        <div class="btn-group">
          <button
            class="btn btn-outline-secondary d-flex align-items-center"
            style="gap: 5px"
            [class.active]="viewType === 'list'"
            (click)="setView('list')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
              />
            </svg>
            List
          </button>
          <button
            class="btn btn-outline-secondary d-flex align-items-center"
            style="gap: 5px"
            [class.active]="viewType === 'card'"
            (click)="setView('card')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-grid"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
              />
            </svg>
            Cards
          </button>
        </div>
      </div>
    </div>

    <!-- ================= LIST VIEW ================= -->
    <div *ngIf="viewType === 'list'" class="card mb-2">
      <div class="table-responsive list-view-table">
        <table class="table align-middle mb-0">
          <thead class="table-secondary">
            <tr>
              <th>Template</th>
              <th>Journey Name</th>
              <th>Theme Name</th>
              <th>Created On</th>
              <th class="text-center">Active</th>
              <th class="text-end">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of templateFilterData">
              <td style="max-width: 400px; min-width: 400px; text-wrap: auto">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <div class="list-view-img">
                    <img
                      #imgRef
                      (click)="openPreview(item, $event.target.src)"
                      *ngIf="item.theme_screenshot"
                      [src]="item.theme_screenshot"
                      class="rounded border cursor-pointer"
                      width="60"
                      height="60"
                      alt="Thumbnail"
                      (error)="setValue($event, item)"
                      style="min-width: 60px"
                    />
                    <img
                      *ngIf="!item.theme_screenshot"
                      class="rounded border opacity-50"
                      style="opacity: 0.5; min-width: 60px"
                      width="60"
                      height="60"
                      src="../../../../assets/images/custom/no-image.jpg"
                      alt="No Image"
                    />
                  </div>
                  <div class="fw-medium">
                    <div>{{ item.template_name }}</div>
                    <div class="text-muted d-inline-block">
                      <span
                        class="subject-text expanded align-middle"
                        #subTextRef
                        >{{ item.template_subject }}</span
                      >
                      <span
                        (click)="showToggle($event, subTextRef)"
                        *ngIf="item.template_subject?.length > 30"
                        class="show-more-btn pl-1"
                        >{{ expandBtnText }}</span
                      >
                    </div>
                    <div
                      class="d-flex align-items-center gap-2 mt-1"
                      style="gap: 5px"
                    >
                      <!-- <div class="btn btn-info btn-sm badge rounded-pill">
                        {{ item.template_type }}
                      </div> -->
                      <button
                        *ngIf="item.theme_screenshot"
                        class="btn btn-sm img-prev-btn-list"
                        (click)="openPreview(item, item.theme_screenshot)"
                      >
                        Preview
                      </button>
                    </div>
                  </div>
                </div>
              </td>
              <td style="max-width: 200px; text-wrap: auto">
                <span class="small">{{ item?.journey_name }}</span>
              </td>
              <td style="max-width: 200px; text-wrap: auto">
                <span class="small">{{ item.theme_names }}</span>
              </td>
              <td>{{ item.createdon | date: "MMM d, yyyy HH:mm" }}</td>

              <td class="text-center align-middle">
                <button
                  type="button"
                  [class.active]="item.isactive"
                  [class.inactive]="!item.isactive"
                  class="btn btn-sm active-toggle p-0 badge"
                  (click)="updateTemplateStatus(item)"
                >
                  <i
                    [class]="item.isactive ? 'bi-toggle2-on' : 'bi-toggle2-off'"
                    class="bi"
                  ></i>
                </button>
              </td>

              <td class="text-end action-btns">
                <div
                  class="d-flex justify-content-start flex-wrap flex-md-nowrap"
                  style="gap: 10px"
                >
                  <button
                    class="btn btn-sm btn-outline-secondary clone-btn"
                    (click)="cloneEmailTemplate(item)"
                    ngbTooltip="Clone"
                    placement="top"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-copy"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                      />
                    </svg>
                    <!-- Clone -->
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary move-btn"
                    (click)="moveTemplate(item)"
                    ngbTooltip="Move"
                    placement="top"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrows-move"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8"
                      />
                    </svg>
                    <!-- Move -->
                  </button>
                  <button
                    class="btn btn-sm btn-outline-primary edit-btn"
                    (click)="editEmailTemplate(item.id)"
                    ngbTooltip="Edit"
                    placement="top"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-pencil"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"
                      />
                    </svg>
                    <!-- Edit -->
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger delete-btn"
                    (click)="deleteEmailTemplate(item.id)"
                    ngbTooltip="Delete"
                    placement="top"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-trash3"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"
                      />
                    </svg>
                    <!-- Delete -->
                  </button>
                </div>
              </td>
            </tr>
            <tr
              *ngIf="companyObj.length === 0"
              style="text-align: center; width: 100%"
            >
              <td colspan="6"><p>No Result Available</p></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ================= CARD VIEW ================= -->
    <div *ngIf="viewType === 'card'" class="card-view mb-2">
      <div class="card-col" *ngFor="let item of templateFilterData">
        <div class="card h-100 shadow-sm m-0">
          <div class="position-relative card-img">
            <div class="img-prev-btn-wrapper px-3 pt-3">
              <button
                *ngIf="item.theme_screenshot"
                class="btn btn-sm btn-primary img-prev-btn"
                (click)="openPreview(item, item.theme_screenshot)"
              >
                Preview
              </button>
            </div>
            <img
              #imgRef
              (click)="openPreview(item, $event.target.src)"
              *ngIf="item.theme_screenshot"
              [src]="item.theme_screenshot"
              class="card-img-top cursor-pointer"
              alt="Template Preview"
              (error)="setValue($event, item)"
            />
            <img
              *ngIf="!item.theme_screenshot"
              class="rounded border opacity-50"
              style="opacity: 0.5"
              src="../../../../assets/images/custom/no-image.jpg"
              alt="No Image"
            />
          </div>

          <div class="card-body overflow-visible pb-3">
            <div
              class="d-flex align-items-center justify-content-between pb-2"
              style="gap: 10px"
            >
              <div
                class="d-flex align-items-center"
                style="gap: 5px; margin-top: -5px"
              >
                <button
                  type="button"
                  [class.active]="item.isactive"
                  [class.inactive]="!item.isactive"
                  class="btn btn-sm active-toggle p-0 me-3"
                  (click)="updateTemplateStatus(item)"
                >
                  <i
                    [class]="item.isactive ? 'bi-toggle2-on' : 'bi-toggle2-off'"
                    class="bi"
                  ></i>
                </button>
                <span class="small text-muted">{{
                  item.isactive ? "Active" : "Inactive"
                }}</span>
              </div>
              <button
                *ngIf="item.theme_screenshot"
                class="btn btn-sm btn-primary img-prev-btn py-1 d-flex d-md-none"
                (click)="openPreview(item, item.theme_screenshot)"
              >
                Preview
              </button>
            </div>
            <h6 class="card-title m-0">
              {{ item.template_name }}
            </h6>
            <div class="text-muted d-flex flex-column py-2">
              <span class="subject-text expanded" #subTextRef>{{
                item.template_subject
              }}</span>
              <span
                (click)="showToggle($event, subTextRef)"
                *ngIf="item.template_subject?.length > 30"
                class="show-more-btn"
                >{{ expandBtnText }}</span
              >
            </div>
            <!-- <span class="badge rounded-pill btn btn-info mb-2">
              {{ item.template_type }}
            </span> -->
            <div class="d-flex align-items-center flex-wrap" style="gap: 5px">
              <span> {{ item?.journey_name }} - </span>
              <span>
                {{ item.theme_names }}
              </span>
            </div>

            <p class="text-muted small mb-0">
              Created on - {{ item.createdon | date: "MMM d, yyyy HH:mm" }}
            </p>
          </div>

          <div
            class="card-footer bg-white border-top-0 d-flex justify-content-end pt-0 pb-4"
          >
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div
                class="d-flex justify-content-start flex-wrap card-action-btns"
                style="gap: 10px"
              >
                <button
                  class="btn btn-sm btn-outline-secondary clone-btn"
                  (click)="cloneEmailTemplate(item)"
                  ngbTooltip="Clone"
                  placement="top"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-copy"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                    />
                  </svg>
                  <!-- Clone -->
                </button>
                <button
                  class="btn btn-sm btn-outline-secondary move-btn"
                  (click)="moveTemplate(item)"
                  ngbTooltip="Move"
                  placement="top"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrows-move"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8"
                    />
                  </svg>
                  <!-- Move -->
                </button>
                <button
                  class="btn btn-sm btn-outline-primary edit-btn"
                  (click)="editEmailTemplate(item.id)"
                  ngbTooltip="Edit"
                  placement="top"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-pencil"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"
                    />
                  </svg>
                  <!-- Edit -->
                </button>
                <button
                  class="btn btn-sm btn-outline-danger delete-btn"
                  (click)="deleteEmailTemplate(item.id)"
                  ngbTooltip="Delete"
                  placement="top"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"
                    />
                  </svg>
                  <!-- Delete -->
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="viewType === 'card' && companyObj.length === 0"
        style="text-align: center; width: 100%; margin-top: 40px"
      >
        <p>No Result Available</p>
      </div>
      <div class="mt-2 text-center difPagination" *ngIf="totalCount > 10">
        <ngb-pagination
          [collectionSize]="totalCount"
          [(page)]="page"
          [maxSize]="2"
          [rotate]="true"
          (pageChange)="onPageChange()"
          aria-label="Custom pagination"
        >
          <ng-template ngbPaginationPrevious>Prev</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
  <!-- Image Preview Popup -->
  <app-cb-email-image-preview
    *ngIf="selectedImage"
    [imageUrl]="selectedImage"
    [templateName]="selectedTemplateName"
    (closed)="closePreview()"
  ></app-cb-email-image-preview>

  <!-- Move Modal Component -->
  <app-cb-move-template-modal
    [modalData]="moveModalData"
    [modalTitle]="moveModalTitle"
    [currentJourneyData]="currentJourneyData"
    [isMoveModalOpen]="isMoveModalOpen"
    (closed)="closeMoveModal()"
    (refreshTemplateList)="refreshTemplateList()"
  ></app-cb-move-template-modal>

  <!-- Clone Modal Component -->
  <app-cb-clone-template-modal
    [templateData]="currentCloneData"
    [modalTitle]="cloneModalTitle"
    [isCloneModalOpen]="isCloneModalOpen"
    (closed)="closeCloneModal()"
    (refreshTemplateList)="refreshTemplateList()"
  ></app-cb-clone-template-modal>
</div>
